<section :class="[{ [$style.sisPill]: pillInSis }, $style.pillsSection]" v-if="foundriesCopy.length >= 1">
  <div
    :class="[$style.pillsWrapper, { [$style.verticalPillWrapper]: verticalScroll}, { [$style.borderClass]: containerHeight >= inheritedContainerHeight }]"
  >
    <img
      alt="arrow-left"
      @click="scrollLeft"
      :class="$style.buttonleft"
      :src="scrollLeftButton"
      v-if="shouldShowScrollLeftButton"
    />
    <div :class="$style.foundryContainer" ref="foundryContainer" @scroll="handleScroll" :style="{ maxHeight: inheritedContainerHeight + 'px' }">
      <button
        v-for="(item, i) in foundriesCopy"
        :key="item.value"
        :class="[$style.foundryDetails, { [$style.warningWordsStyle]: checkForWarningWords(item.name) }]"
        :index="i"
      >
        <MdTypography
          :data-qa-id="`tagNmae-${i}`"
          :class="$style.foundryName"
          tag="p"
          :color="checkForWarningWords(item.name) ? 'orange-squash--500' :'spirits--700'"
          variant="body2--medium"
        >
          {{ item.label || item.name }}
        </MdTypography>
        <MdIconClose
          :data-qa-id="`removeTagIcon-${i}`"
          :class="$style.crossIcon"
          @click="removeFoundry(item)"
          :color="checkForWarningWords(item.name) ? 'orange-squash--500' :'spirits--700'"
        />
      </button>
    </div>
    <img
      alt="arrow-right"
      @click="scrollRight"
      :class="$style.buttonRight"
      :src="scrollRightButton"
      v-if="shouldShowScrollRightButton"
    />
  </div>
  <MdTypography v-if="arrayOfWarningWords.length > 0" tag="p" color="orange-squash--500" variant="body2--regular" data-qa-id="warning">
    {{$t('pages.profile.foundry_profile.warning_word_error_message_tags')}}
  </MdTypography>
  <MdTypography v-if="showMaxTagsWarning" tag="p" color="orange-squash--500" variant="body2--regular">
    {{$t('pages.submissions.components.descriptions.tags.max_tag_error_message')}}
  </MdTypography>
  <div :class="$style.clearAll" v-if="showClearAll && !removeTagsForSis">
    <p @click="removeAll()">Clear all</p>
  </div>
</section>
<div v-if="removeTagsForSis" :class="$style.tagsCountContainer">
  <MdTypography v-if="showTagsCount" :class="[$style.tagsCount, { [$style.warningTagsCount]: arrayOfWarningWords.length }]" tag="p" variant="body2--regular" :color="arrayOfWarningWords.length ? 'orange-squash--500' : 'spirits--900'">
    {{$t('pages.submissions.components.descriptions.tags.tagCountRatio', {current: foundriesCopy.length, maximum: maximumTagCount})}}
  </MdTypography>
  <MdButton v-if="foundriesCopy.length > 0" @click="removeAll()" size="small" :disabled="!foundriesCopy.length" variant="bordered" data-qa-id="removeAllButton">
    {{clearAllText}}
  </MdButton>
</div>
